import { Component, inject, model } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Playlist } from '@shared/interfacres/playlist';
import { MatButton } from '@angular/material/button';
import { FileUploaderComponent } from '@shared/components/file-uploader/file-uploader.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-edit-playlist-data-dialog',
  templateUrl: 'edit-playlist-data-dialog.html',
  styleUrl: './edit-playlist-data-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,

    FileUploaderComponent,

    MatIcon,
  ],
})
export class EditPlaylistDataDialog {
  readonly dialogRef = inject(MatDialogRef<EditPlaylistDataDialog>);
  readonly data = inject<Playlist>(MAT_DIALOG_DATA);
  readonly name = model('');
  // readonly description = model('');

  file: File | null = null;
  image = '';

  constructor() {
      this.name.set(this.data?.name || '');
      // this.description.set(this.data?.description || '');
      this.image = this.data?.image || ''
  }

  attachFile(file: File[]) {
    this.file = file[0];

    //Show image preview
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      this.image = event.target!.result as string;
    }
    reader.readAsDataURL(this.file);
  }

  save() {
    this.dialogRef.close({
      name: this.name(),
      description: '',
      isPublic: true,
      file: this.file,
      image: this.image
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
